import { Inject, ModuleWithProviders, NgModule } from '@angular/core';

import { I18nService, TranslationsProvider } from './i18n.service';
import {
  CONTEXT_EDITOR_ENABLED,
  ENABLE_TRANSLATION_UI_KEY,
  I18nConfig,
  I18N_CONFIG_TOKEN,
} from './i18n.tokens';
import { MultilangTranslationService } from './multilang/multilang-translation.service';
import { PhraseAppEditorService } from './phrase-app/phrase-app-editor.service';
import { PhraseAppTranslationService } from './phrase-app/phrase-app-translation.service';
import { TranslatePipe } from './translate.pipe';

export function contextEditorEnabledFlagFactory(config: I18nConfig): boolean {
  return config.editorEnabled && JSON.parse(localStorage.getItem(ENABLE_TRANSLATION_UI_KEY)!);
}

@NgModule({
  imports: [TranslatePipe],
  exports: [TranslatePipe],
})
export class I18nModule {
  public static forPhraseApp(config: I18nConfig): ModuleWithProviders<I18nModule> {
    return {
      ngModule: I18nModule,
      providers: [
        I18nService,
        PhraseAppTranslationService,
        { provide: TranslationsProvider, useExisting: PhraseAppTranslationService },
        PhraseAppEditorService,
        {
          provide: I18N_CONFIG_TOKEN,
          useValue: config,
        },
        {
          provide: CONTEXT_EDITOR_ENABLED,
          useFactory: contextEditorEnabledFlagFactory,
          deps: [[Inject, I18N_CONFIG_TOKEN]],
        },
      ],
    };
  }

  public static forMultilang(): ModuleWithProviders<I18nModule> {
    return {
      ngModule: I18nModule,
      providers: [
        I18nService,
        MultilangTranslationService,
        { provide: TranslationsProvider, useExisting: MultilangTranslationService },
      ],
    };
  }
}

export { TranslatePipe };
